module.exports = __webpack_public_path__ + "img/Sent Mail.b3ed019c.svg";